// CollectionEmptyState.jsx - Empty state display for collection
import React from "react";

/**
 * Empty state component shown when collection has no games
 */
function CollectionEmptyState() {
  return (
    <div className="empty-state">
      <h4>No Games Found</h4>
      <p>
        Your collection seems to be empty. Refresh this page if this seems wrong.
        Or, Start adding your games using the &apos;+&apos; button,
        or set your BGG ID in Profile and sync your collection from BoardGameGeek
        to get started!
      </p>
    </div>
  );
}

export default CollectionEmptyState;
